import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Link as LinkIcon } from "lucide-react";
import AddLinkForm from "../forms/AddLinkForm";
import { KnowledgeItem } from "@/services/fileService";

interface LinkAdditionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: (item?: KnowledgeItem) => void;
  agentId?: string | null;
  initialValues?: {
    title?: string;
    url?: string;
    description?: string;
  };
}

const LinkAdditionModal = ({ open, onOpenChange, onSuccess, agentId, initialValues }: LinkAdditionModalProps) => {
  const handleSuccess = (item?: KnowledgeItem) => {
    if (onSuccess) {
      onSuccess(item);
    } else {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <LinkIcon className="h-5 w-5 text-green-600" />
            Add Website to Knowledge Base
          </DialogTitle>
          <DialogDescription>
            Add a website or web page that will be crawled and made searchable by {agentId ? "your agent" : "all agents in your organization"}
          </DialogDescription>
        </DialogHeader>

        <div className="mt-4">
          <AddLinkForm onSuccess={handleSuccess} agentId={agentId} initialValues={initialValues} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LinkAdditionModal; 